import { useEffect } from 'react';
import { ClockTick } from 'record-it-utils/utils/ClockTick/ClockTick';
import { useEventCallback } from './useEventCallback';

export function useDayTick(callback: () => void): void {
  const wrappedCallback = useEventCallback(callback);

  useEffect(() => {
    const disposable = ClockTick.onDayTick(wrappedCallback);

    return () => disposable.dispose();
  }, [wrappedCallback]);
}
